/* eslint-disable no-misleading-character-class */

/* eslint-disable no-prototype-builtins */
import React, { ComponentProps, ComponentType, ReactElement } from 'react'

import get from 'lodash.get'
import isPlainObject from 'lodash.isplainobject'

const ATTRIBUTE_REGEX =
  /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|onPointerOu|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|unicodeRange|mathematical|vAlphabetic|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|autoPlay|o(?:verflow|pen)|f(?:o(?:ntSize|rm?)|il(?:ter|l))|r(?:e(?:quired|sult|f))?|divisor|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|i(?:temRef|n2|s)|t(?:arget[XY]|o)|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|prefix|typeof|itemID|s(?:t(?:roke|art)|hape|cope|rc)|t(?:arget|ype)|(?:stri|la)ng|a(?:ccept|s)|m(?:edia|a(?:sk|x)|in)|x(?:mlns)?|width|value|size|href|k(?:ey)?|end|low|by|i[dn]|y[12]|g[12]|x[12]|f[xy]|[yz])$/
/* From DOMProperty */
const ATTRIBUTE_NAME_START_CHAR =
  ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD'
const ATTRIBUTE_NAME_CHAR = `${ATTRIBUTE_NAME_START_CHAR}\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040`
const isCustomAttribute = RegExp.prototype.test.bind(
  new RegExp(`^(x|data|aria)-[${ATTRIBUTE_NAME_CHAR}]*$`)
)
/* Custom filter list */
const OTHER_ATTRIBUTE_REGEX = /^(action)/g
export const isPropValid = (name: string) => {
  return (
    (ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase())) &&
    !OTHER_ATTRIBUTE_REGEX.test(name)
  )
}
/**
 * Filters our custom non-default React props.
 */
export function getValidProps(props: Record<string, unknown>) {
  return Object.keys(props).reduce((validProps, prop) => {
    if (isPropValid(prop)) {
      validProps[prop] = props[prop]
    }
    return validProps
  }, {} as Record<string, unknown>)
}
/**
 * Retrieves the name of a given React component.React.
 */
export function getComponentName(Component: unknown): string {
  if (!isReactComponent(Component)) return ''
  return (
    get(Component, 'displayName') ||
    get(Component, 'name') ||
    // need to also check the type.displayName and type.name
    // when checking component children
    get(Component, 'type.displayName') ||
    get(Component, 'type.name') ||
    'Component'
  )
}
/**
 * Attempts to retrieve a React key from a child when iterating.
 */
export const getComponentKey = (
  Component: unknown,
  index?: number | string,
  fallback?: string
): string | undefined => {
  if (!React.isValidElement(Component) && !isPlainObject(Component)) {
    return undefined
  }
  let key
  const typedComponent = Component as ReactElement
  if (typedComponent.props && typedComponent.props.id) {
    key = typedComponent.props.id
  } else if (typedComponent.key != null) {
    key = typedComponent.key
  } else if (fallback != null) {
    key = fallback
  } else if (index != null) {
    key = `unsafeComponentKey-${index}`
  } else {
    key = typedComponent.key || undefined
  }
  return key
}
/**
 * Checks to see if React is v15, by checking the provided component.
 */
function isReact15(Component: ComponentType) {
  return isPlainObject(Component) && get(Component, '_reactInternalInstance')
}
/**
 * Checks to see if React is v16, by checking the provided component.
 */
function isReact16(Component: ComponentType) {
  return isPlainObject(Component) && get(Component, '_reactInternalFiber')
}
/**
 * Checks to see if React is v15 and up, by checking the provided component.
 */
function isReact15Up(Component: ComponentType) {
  return isReact15(Component) || isReact16(Component)
}
/**
 * Determines if the object is a React component.
 */
export function isReactComponent(
  Component: unknown
): Component is ComponentType {
  // Stateless functional components
  if (typeof Component === 'function') {
    return true
  } else if (isPlainObject(Component)) {
    return (
      isReact15Up(Component as ComponentType) ||
      (Component as object).hasOwnProperty('$$typeof') ||
      (Component as object).hasOwnProperty('ref')
    )
  }
  return false
}
/**
 * Pluck out the differences between previous/next props/state.
 * Useful for debugging component update/renders.
 */
export function getShallowDiffs(
  previous: ComponentProps<any>,
  next: ComponentProps<any>
) {
  const diffs = Object.keys(previous).filter(key => previous[key] !== next[key])
  const previousProps = diffs.reduce((previousProps, key) => {
    previousProps[key] = previous[key]
    return previousProps
  }, {} as Record<string, unknown>)
  const nextProps = diffs.reduce((nextProps, key) => {
    nextProps[key] = next[key]
    return nextProps
  }, {} as Record<string, unknown>)
  return { diffs, previous: previousProps, next: nextProps }
}
/**
 * Retrieves the document where the React Component has been
 * mounted to.
 */
export function getDocumentFromComponent(Component: ComponentType) {
  if (!isReactComponent(Component)) return document
  // React 16.x
  if (isReact16(Component)) {
    const levelOneCheck = get(
      Component,
      '_reactInternalFiber.return.stateNode.ownerDocument'
    )
    const levelTwoCheck = get(
      Component,
      '_reactInternalFiber._debugOwner.return.stateNode.ownerDocument'
    )
    const levelThreeCheck = get(
      Component,
      '_reactInternalFiber._debugOwner._debugOwner.return.stateNode.ownerDocument'
    )
    return levelOneCheck || levelTwoCheck || levelThreeCheck || document
  }
  // React 15.x
  /* istanbul ignore else */
  if (isReact15(Component)) {
    return get(Component, '_reactInternalInstance._context.document', document)
  }
  /* istanbul ignore next */
  return document
}
/**
 * Wraps a retrieved the name of a given React component.
 */
export function wrapComponentName(Component: unknown, wrapperName?: string) {
  const componentName = getComponentName(Component)
  if (!wrapperName) return componentName
  return `${wrapperName}(${componentName})`
}
/**
 * Checks to see if a React component is a specific type.
 */
export const isComponentOneOfType = (
  Component: ComponentType,
  types: string | string[]
) => {
  if (
    !isReactComponent(Component) ||
    (!Array.isArray(types) && typeof types !== 'string')
  )
    return false
  return React.isValidElement(Component) &&
    Component.type &&
    Array.isArray(types)
    ? types.some(o => o === Component.type)
    : get(Component, 'type') === types
}
/**
 * Checks to see if a React component is a "span" DOM type.
 * @param {React.Component} Component A React component.
 * @returns {boolean} Truthiness.
 */
export const isNativeSpanType = (Component: ComponentType) => {
  const types = ['a', 'b', 'bold', 'em', 'i', 'span', 'strong', 'u']
  return isComponentOneOfType(Component, types)
}

export function mergeRefs<T>(
  ...inputRefs: (React.Ref<T> | undefined)[]
): React.Ref<T> | React.RefCallback<T> {
  const filteredInputRefs = inputRefs.filter(Boolean)

  if (filteredInputRefs.length <= 1) {
    const firstRef = filteredInputRefs[0]

    return firstRef || null
  }

  return function mergedRefs(ref) {
    for (const inputRef of filteredInputRefs) {
      if (typeof inputRef === 'function') {
        inputRef(ref)
      } else if (inputRef) {
        ;(inputRef as React.MutableRefObject<T | null>).current = ref
      }
    }
  }
}
